<div class="card company-card" role="button">
  <div class="card-body p-2">
    <div class="container">
      <div class="row pb-2">
        <div class="d-flex">
          <app-company-logo [company]="company" [scale]="1.1" [maxTitleLines]="2" [showTitleFailover]="true"></app-company-logo>
          <div class="col text-end pe-0">
            <h2 class="mt-2 rank">{{company.rank | number}}</h2>
          </div>
        </div>
      </div>

      <ng-container *ngIf="company.is_premium else visibleCompany">
        <div class="row">
          <div class="col ps-1">
            <div class="d-flex">
              <div class="data-point-title short"><p class="text-body-tertiary">Team Batting<br>Average </p></div>
              <div class="align-self-center fs-5"><span class="fw-bold pe-3 blurred">{{0.001 | number : '1.3-3'}}</span></div>

              <div class="data-point-title"><p class="text-body-tertiary">Gender Influence<br>Gap </p></div>
              <div class="align-self-center fs-5"><span class="fw-bold blurred">{{0.001 | percent}}</span></div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col ps-1">
            <div class="d-flex">
              <div class="data-point-title short align-self-center"><p class="text-body-tertiary">TSR</p></div>
              <div class="align-self-center fs-5"><span class="fw-bold pe-3 blurred">{{0.001 | number : '1.3-3'}}</span></div>

              <div class="data-point-title"><p class="text-body-tertiary">Diversity Influence<br>Gap</p></div>
              <div class="align-self-center fs-5"><span class="fw-bold blurred">{{0.001 | percent}}</span></div>
            </div>
          </div>
        </div>
      </ng-container>
      <ng-template #visibleCompany>
        <div class="row">
          <div class="col ps-1">
            <div class="d-flex">
              <div class="data-point-title short"><p class="text-body-tertiary">Team Batting<br>Average </p></div>
              <div class="align-self-center fs-5"><span class="fw-bold pe-3">{{company.team_power | number : '1.3-3'}}</span></div>

              <div class="data-point-title"><p class="text-body-tertiary">Gender Influence<br>Gap </p></div>
              <div class="align-self-center fs-5"><span class="fw-bold">{{company.gender_influence_gap / 100 | percent}}</span></div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col ps-1">
            <div class="d-flex">
              <div class="data-point-title short align-self-center"><p class="text-body-tertiary">TSR</p></div>
              <div class="align-self-center fs-5"><span class="fw-bold pe-3">{{company.weighted_tsr_win_rate | number : '1.3-3'}}</span></div>

              <div class="data-point-title"><p class="text-body-tertiary">Diversity Influence<br>Gap</p></div>
              <div class="align-self-center fs-5"><span class="fw-bold">{{company.diversity_influence_gap / 100 | percent}}</span></div>
            </div>
          </div>
        </div>
      </ng-template>
    </div>
  </div>
</div>
